import {useAuthStore} from "../store/auth.store";
import {useEffect, useState} from "react";
import { useTranslation } from "../hooks/useTranslation";
import {useLoan} from "../hook/partner/loan.partner.hook";
import {PartnerApi} from "../api/partner.api";
import {useBreadcrumbsStore} from "../store/breadcrumbs.store";
import {useLoansStore} from "../store/loans.store";
import Comments from "../components/Comments/Comments";
import LoanAddItemModal from "../components/modals/loan/LoanAddItemModal";
import {toast} from "react-toastify";
import {useParams} from "react-router";

function Loan() {
    const { t } = useTranslation();
    const {id} = useParams();
    const [reload, setReload] = useState(0);
    const loanMutation = useLoan();

    const token = useAuthStore((state) => state.token);
    const loan = useLoansStore((state) => state.loan);

    const [showModal, setShowModal] = useState(false);

    const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
    const setPagename = useBreadcrumbsStore((state) => state.setPagename);
    useEffect(() => {
        setPagename(
            loan
                ? loan.company.name +
                " " +
                (loan.create_date && loan.create_date != "0000-00-00"
                    ? new Date(loan.create_date).toLocaleDateString()
                    : "-")
                : ""
        );
        setBreadcrumbs([
            {
                name: t("loans.title"),
                link: "/zapujcky",
            },
        ]);
    }, [loan, id]);

    useEffect(() => {
        if (token) {
            loanMutation.mutate({token, id});
        }
    }, [token, id, reload]);

    if (!loan) {
        return <></>;
    }

    const deleteItem = (item_id) => {
        const result = PartnerApi.loanItemDelete({
            token,
            item_id,
            id,
        });
        result
            .then((result) => {
                if ("error" in result) {
                    toast.error(result.error);
                    return;
                }
                if ("loan_id" in result) {
                    toast.success(t("common.deleted"));
                    setReload(reload + 1);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <>
            <div className="card ">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-3">
                            <table className="table table-striped table-bordered">
                                <tbody>
                                <tr>
                                    <td colSpan={2}>
                      <span
                          className={
                              "float-end badge badge-" +
                              loan.current_state.state_style
                          }
                      >
                        {loan.current_state.state_name}
                      </span>
                                        <strong>{t("loans.customer")}</strong>
                                        <br/>
                                        {loan.company.name}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{t("loans.requestDate")}</strong>
                                        <br/>
                                        {loan.create_date && loan.create_date != "0000-00-00"
                                            ? new Date(loan.create_date).toLocaleDateString()
                                            : "-"}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{t("loans.loanDate")}</strong>
                                        <br/>
                                        {loan.loan_from && loan.loan_from != "0000-00-00" ? (
                                            <>
                                                {loan.loan_from && loan.loan_from != "0000-00-00"
                                                    ? new Date(loan.loan_from).toLocaleDateString()
                                                    : "-"}
                                                &nbsp; -&nbsp;
                                                {loan.loan_to && loan.loan_to != "0000-00-00"
                                                    ? new Date(loan.loan_to).toLocaleDateString()
                                                    : "-"}
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-9">
                            {loan.current_state.state_id === 1 && (
                                <div className="mb-4">
                                    <LoanAddItemModal
                                        show={showModal}
                                        handleClose={() => setShowModal(false)}
                                        loan_id={loan.loan_id}
                                        callback={() => setReload(reload + 1)}
                                        loan_from={loan.loan_from}
                                        loan_to={loan.loan_to}
                                    />
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => setShowModal(true)}
                                    >
                                        {t("loans.addProduct")}
                                    </button>
                                </div>
                            )}
                            <div className="row">
                                {loan.items?.length > 0 ? (
                                    loan.items?.map((item, index) => (
                                        <div className="col-md-4 mb-10" key={index}>
                                            <div className="card p-4 h-100">
                                                <img
                                                    className="mw-100"
                                                    style={{
                                                        aspectRatio: "2 / 1",
                                                        objectFit: "contain",
                                                    }}
                                                    src={
                                                        PartnerApi.url +
                                                        "/vendor/" +
                                                        item.hardware?.product?.vendor_id +
                                                        "/logo.jpg"
                                                    }
                                                    alt={item.hardware?.product?.vendor_name}
                                                />
                                                <h4>{item.hardware?.product?.product_family}</h4>
                                                <p>{item.hardware?.product?.name}</p>
                                                <table className="table table-bordered">
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <strong>SN:</strong>
                                                            <span className={"float-end"}>
                                  {item.hardware?.sn}
                                </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <strong>{t("loans.requestedDateFrom")}:</strong>
                                                            <span className={"float-end"}>
                                  {item.loan_from &&
                                      item.loan_from != "0000-00-00" &&
                                      new Date(
                                          item.loan_from
                                      ).toLocaleDateString()}
                                </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <strong>{t("loans.requestedDateTo")}:</strong>
                                                            <span className={"float-end"}>
                                  {item.loan_to &&
                                      item.loan_to != "0000-00-00" &&
                                      new Date(item.loan_to).toLocaleDateString()}
                                </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <strong>{t("loans.sentDate")}:</strong>
                                                            <span className={"float-end"}>
                                  {item.sent_date &&
                                      item.sent_date != "0000-00-00" &&
                                      new Date(
                                          item.sent_date
                                      ).toLocaleDateString()}
                                </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <strong>{t("loans.returnDate")}:</strong>
                                                            <span className={"float-end"}>
                                  {item.returned_date &&
                                      item.returned_date != "0000-00-00" &&
                                      new Date(
                                          item.returned_date
                                      ).toLocaleDateString()}
                                </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                {loan.current_state.state_id === 1 && (
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={() =>
                                                            window.confirm(t("loans.confirmDelete")) &&
                                                            deleteItem(item.loan_item_id)
                                                        }
                                                    >
                                                        {t("common.remove")}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="alert alert-primary">
                                        {t("loans.noDevices")}
                                    </div>
                                )}
                            </div>
                            <h2>{t("opportunities.notes")}</h2>
                            <Comments
                                objectId={loan.loan_id}
                                objectType={"loan"}
                                callback={() => setReload(reload + 1)}
                                comments={loan.comments}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Loan;
